import DocsConfig from '@tencent/docs-config';
const appConfigInstance = DocsConfig.getInstance();
const npmConfig = appConfigInstance.getConfig('npm["@tencent/docs-design-resources"]')
let p = (!!npmConfig && npmConfig.CDN_ORIGIN) || 'https://docs.gtimg.com/docs-design-resources';
p = p + '/cooperation/ai/template/template_ppt_simple_geometry_blue/'
export function getTemplateThumbnail1() { return p+'template_thumbnail_1-d20160b038.png'; };
export function getTemplateThumbnail10() { return p+'template_thumbnail_10-b54ab3a899.png'; };
export function getTemplateThumbnail2() { return p+'template_thumbnail_2-09f3910065.png'; };
export function getTemplateThumbnail3() { return p+'template_thumbnail_3-8db8737283.png'; };
export function getTemplateThumbnail4() { return p+'template_thumbnail_4-67de4e26eb.png'; };
export function getTemplateThumbnail5() { return p+'template_thumbnail_5-9156a77bc1.png'; };
export function getTemplateThumbnail6() { return p+'template_thumbnail_6-a2610bd3f1.png'; };
export function getTemplateThumbnail7() { return p+'template_thumbnail_7-236e983066.png'; };
export function getTemplateThumbnail8() { return p+'template_thumbnail_8-63837088bc.png'; };
export function getTemplateThumbnail9() { return p+'template_thumbnail_9-8199d11c64.png'; };
